import { IImageObject } from 'types/gallery';

const getImageUrlBySize = (
  imageObject: IImageObject | null,
  sizeIndex: number,
): string => imageObject?.imageSizeUrls[sizeIndex]?.url || '';

export default getImageUrlBySize;
